import styled from 'styled-components'

import { theme } from '../../styles/theme'

interface IContainerProps {
  selected: boolean
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: ${theme.border.mediumRadius};
  padding: 16px;
  color: ${(props) => (props.selected ? theme.colors.green2 : theme.colors.gray400)};
  border: ${(props) => (props.selected ? `2px solid ${theme.colors.green2}` : 'none')};
  background-color: ${(props) => (props.selected ? theme.colors.lightGreen : theme.colors.white)};
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PlanNameWithCheck = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const PlanName = styled.div`
  font-size: ${theme.font.sizes.small};
`

export const Radio = styled.input`
  position: relative;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid ${theme.colors.gray400};
  border-radius: 100%;
  cursor: pointer;

  &:checked {
    border: 1px solid ${theme.colors.green2};

    &::before {
      content: '';
      width: 9px;
      height: 9px;
      background-color: ${theme.colors.green2};
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`

export const PricesContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
`

export const Price = styled.div`
  font-size: ${theme.font.sizes.xxlarge};
  font-weight: ${theme.font.bold};
`

export const PriceDescount = styled.div`
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.normal};
  text-decoration: line-through;
`
